import { createSelector } from 'reselect';

import { formatPhoneNumber } from 'shared/utils/formatPhoneNumber';

import { getCoworkingOperator } from './getCoworkingOperator';

export const coworkingOperatorPhoneSelector = createSelector(getCoworkingOperator, operator => {
  const phone = operator?.phone;
  if (!phone) {
    return null;
  }

  try {
    return formatPhoneNumber(phone);
  } catch (_e) {
    return null;
  }
});
